
export class ParseDataMobile{
    public static parse(data){
        return  data?
            data.split('/').reverse().join('-'):
            data
    }
}